'use client';

import { useIsClient } from 'usehooks-ts';
import { useUserData } from '@/contexts/LoginContext';
import React from 'react';
import { Link } from '../PrivateLink/ServerLink';

type Props = {
  loginedLink: string;
  unLoginedLink: string;
  children: React.ReactNode;
  linkClassName: string;
  title?: string;
};

export const LoginVaryLink: React.FC<Props> = ({ loginedLink, unLoginedLink, children, title, linkClassName }) => {
  const userData = useUserData();
  const hasMounted = useIsClient();

  const href = hasMounted && userData ? loginedLink : unLoginedLink;

  return (
    <Link title={title} href={href} className={linkClassName}>
      {children}
    </Link>
  );
};
